module.exports = __webpack_public_path__ + "static/blog21-2d81aeabe7f02db5b226bf6a0c3c905f.png";